import DesignButton from 'components/button/DesignButton';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';

const Unauthorized = () => {
  const navigate = useNavigate();
  const auth = useAuth();
  return (
    <div className="flex h-screen items-center justify-center bg-design-black">
      <div className="flex h-3/6 w-3/6 flex-col items-center">
        <img className="h-36" alt="login log" src="/sameday_logo.png" />
        <h4 className="mt-3 mb-4 uppercase text-white">401 Unauthorized</h4>
        <div>
          <DesignButton
            onClickHandler={() => navigate('/')}
            className="mr-2 text-white"
          >
            Back
          </DesignButton>
          <DesignButton
            onClickHandler={async () => {
              await auth.removeUser();
              await auth.signoutRedirect();
            }}
            className="mr-2 text-white"
          >
            Sign out
          </DesignButton>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
